export const ALTERNATIVE_HARDWARE = [
    {
  id: "modern-alt",
  name: "Consoles alternatives modernes",
  brand: "PC",
  type: "console",
  category: "Modern",
  variants: [
    {
      id: "modern-alt-family",
      name: "Modernes",
      versions: [
        {
          id: "ouya",
          name: "Ouya",
          storage: "8 Go",
          disc: false,
          image: "/images/consoles/ouya.png",
        },
        {
          id: "nvidia-shield",
          name: "NVIDIA Shield",
          storage: "16 Go",
          disc: false,
          image: "/images/consoles/nvidia-shield.png",
        },
        {
          id: "google-stadia",
          name: "Google Stadia",
          storage: "",
          disc: false,
          image: "/images/consoles/google-stadia.png",
        },
      ],
    },
  ],
},
]